<template>
  <hm-content title="收银设置">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <!-- <el-form-item label="商户名称："> </el-form-item> -->
      <el-form-item label="收银配置：">
        <el-checkbox-group v-model="ruleForm.smgPayType" :min="1">
          <div v-for="(v, i) in cashierList" :key="i">
            <el-checkbox :label="v.value">{{ v.name }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="交班设置：" prop="handover">
        <el-switch
          v-model="ruleForm.smgHandOver"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="true"
          active-text="开启"
          inactive-text="关闭"
          inactive-value="false"
        >
        </el-switch>
      </el-form-item>
      <el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="save('ruleForm')"
            >保存</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </hm-content>
</template>

<script>
export default {
  name: "cahierSetting",
  data() {
    return {
      cashierList: [
        {
          value: "qrpay",
          name: "扫码收银",
          checked: true,
          id: 1
        },
        {
          value: "cash",
          name: "现金收银",
          id: 2
        },
        {
          value: "card",
          name: "银行卡收银",
          id: 3
        }
        // {
        //   value: 'integral',
        //   name: '积分收银',
        //   id: 4
        // }
      ],
      ruleForm: {
        smgHandOver: "false",
        smgPayType: ["qrpay"]
      },
      rules: {}
    };
  },
  created() {
    this.$store.dispatch("queryCashierConfig").then(res => {
      if (res.code === "0") {
        this.ruleForm.smgHandOver = res.result.smgHandOver;
        this.ruleForm.smgPayType = res.result.smgPayType;
      }
    });
  },
  methods: {
    save() {
      let sortList = [];
      this.cashierList.map(o => {
        this.ruleForm.smgPayType.map(v => {
          if (o.value === v) {
            sortList.push(o);
          }
        });
      });
      sortList = sortList.map(o => o.value);
      this.$store
        .dispatch("setCashierConfig", {
          smgHandOver: this.smgHandOver,
          smgPayType: sortList
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功！",
              type: "success"
            });
          }
        });
    }
  }
};
</script>
